"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.financialWorkflowExtrasShape = exports.financialNotificationRequestSchema = exports.financialCallOptionsSchema = void 0;
/**
 * Shared request sub-schemas reused across every Financial endpoint
 * contract — `financialCallOptionsSchema` mirrors backend's
 * `ApplicationCallOptions` (`src/modules/financial/application/
 * _shared-application/application-call-options.type.ts`, frozen,
 * Stage 5C.3) and `notificationRequestSchema` mirrors `@core/notification`'s
 * `NotificationRequest`. Both are re-declared here rather than
 * imported from Appointment's own `appointment-common.request.ts`
 * (which independently declares the identical `NotificationRequest`
 * shape) — this package does not share wire shapes across bounded
 * contexts, each re-declares its own, kept in lockstep by convention
 * (the same posture every other `*-common.request.ts` file already
 * established).
 */
const zod_1 = require("zod");
exports.financialCallOptionsSchema = zod_1.z.object({
    actorUserId: zod_1.z.string().uuid().optional(),
    reason: zod_1.z.string().optional(),
});
exports.financialNotificationRequestSchema = zod_1.z.object({
    channel: zod_1.z.enum(['email', 'sms', 'whatsapp']),
    to: zod_1.z.string(),
    subject: zod_1.z.string().optional(),
    body: zod_1.z.string(),
});
/** Every mutating Financial endpoint accepts these two optional envelopes alongside its own fields — declared once, spread into each endpoint's own schema via `.extend()`. */
exports.financialWorkflowExtrasShape = {
    options: exports.financialCallOptionsSchema.optional(),
    notification: exports.financialNotificationRequestSchema.optional(),
};
//# sourceMappingURL=financial-common.request.js.map